<template>
  <div class="base-loader" :class="{loading: loading}">
    <!-- <img src="/img/myle/loader.gif"> -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:transparent;display:block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <g transform="rotate(0)"><circle cx="73.801" cy="68.263" fill="#985d4e" r="3" transform="rotate(223.21 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="0s"></animateTransform>
    </circle><circle cx="68.263" cy="73.801" fill="#e0dcb8" r="3" transform="rotate(250.44 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.062s"></animateTransform>
    </circle><circle cx="61.481" cy="77.716" fill="#aca730" r="3" transform="rotate(275.196 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.125s"></animateTransform>
    </circle><circle cx="53.916" cy="79.743" fill="#4f563b" r="3" transform="rotate(296.228 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.187s"></animateTransform>
    </circle><circle cx="46.084" cy="79.743" fill="#9db189" r="3" transform="rotate(314.11 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.25s"></animateTransform>
    </circle><circle cx="38.519" cy="77.716" fill="#60a363" r="3" transform="rotate(328.398 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.312s"></animateTransform>
    </circle><circle cx="31.737" cy="73.801" fill="#2c8c14" r="3" transform="rotate(339.802 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.375s"></animateTransform>
    </circle><circle cx="26.199" cy="68.263" fill="#0a4308" r="3" transform="rotate(348.244 50.0001 50.0001)">
      <animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;360 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s" begin="-0.437s"></animateTransform>
    </circle><animateTransform attributeName="transform" type="rotate" calcMode="spline" values="0 50 50;0 50 50" times="0;1" keySplines="0.5 0 0.5 1" repeatCount="indefinite" dur="1.4925373134328357s"></animateTransform></g>
    </svg>
  </div>
</template>
<script>
  export default {
    name: 'base-loader',
    props: {
      loading: {
        type: Boolean,
        default: false,
        description: 'Loader status'
      }
    },
    data() {
      return {

      }
    },
  }
</script>
<style>
  .base-loader {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background: #ffffffeb;
      z-index: 99999;
      display: none;
  }
  .base-loader.loading {
    display: block;
  }
  .base-loader img,
  .base-loader svg {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 120px;
      height: 120px;
      transform: translate(-50%, -50%);
      border-radius: 5px;
  }
</style>
